import immutableUpdate from 'immutable-update'

const initialState = { 
  menus: null,
  contents: {}
}

const reducers = {

  UI_SAVE_NAVIGATOR_FIELDS: (state, action) => {

    return immutableUpdate(
      state,
      {
        navigatorfields: action.payload.data
      }
    )
  },

  UI_MENUS_LOADED: (state, action) => { 

    return immutableUpdate(
      state,
      {
        menus: action.payload
      }
    )
  },

  UI_CONTENT_LOADED: (state, action) => {

    return immutableUpdate(
      state,
      {
        contents: {
          [action.payload.url]: action.payload.content
        }
      }
    )
  }, 

  UI_GAME_DATA: (state, action) => {
    
    return immutableUpdate(
      state,
      {
        game: action.payload
      }
    )
  },

  UI_SET_CONTEXT: (state, action) => { 
    
    const context = immutableUpdate(
      state.context,
      action.payload
    ) 

    window.playmotiv.context = context
    
    return immutableUpdate(
      state,
      {
        context: context
      }
    )
  },
  
  UI_EVENT_CONTENT_LOADED: (state, action) => { 
    
    return immutableUpdate(
      state,
      {
        eventcontents: {          
          [action.payload.eventid]: action.payload.content 
        }
      }
    )
  },

  WP_CONTENT_LOADED: (state, action) => {

    const { wpId, content } = action.payload
    
    return immutableUpdate(
      state,
      {
        contents: {
          [wpId]: content
        }
      }
    )
  },
  
  UI_NEWS_STATE_LOAD: (state, action) => {   

    let newsstate = {} 

    try {

      const serializedState = localStorage.getItem('PlayCloudGrandPrixNewsState')   
      if (serializedState) {

        newsstate = JSON.parse(serializedState)
      }

    } catch (err) {

      console.log(err)
    }
    
    return immutableUpdate(
      state,
      {
        newsstate: newsstate
      }
    )
  },
  
  UI_NEWS_STATE_SETTED: (state, action) => {

    let newsstate = state.newsstate
    newsstate[action.payload.id] = new Date().getTime()

     localStorage.setItem(
      'PlayCloudGrandPrixNewsState',
      JSON.stringify(newsstate)
    )
    
    return immutableUpdate(
      state,
      {
        newsstate: newsstate
      }
    )
  }
}

const ui = (state = initialState, action) => reducers[action.type] ? 
  reducers[action.type](state, action)
  :
  { ...state }

export default ui 